import React, { useState } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import ButtonComponent from '@/components/Button';
import { ProfileService } from '@/services';
import { ReactComponent as EditIcon } from '@/assets/images/icons/edit.svg';
import ModalSecurityComponent from './ModalSecurity';

function SecurityComponent() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div className="security-form" name="security-form">
      <div className="current-password">
        <p>
          <strong>{t('login.form.fields.password')}</strong>{' '}
          <span className="">***********</span>
        </p>
      </div>
      <ButtonComponent
        onClick={showDrawer}
        icon={<EditIcon />}
        className="btn-edit"
      >
        {t('login.btn_change_password')}
      </ButtonComponent>
      <ModalSecurityComponent
        open={open}
        onClose={onClose}
        onFinish={ProfileService.changePassword}
      />
    </div>
  );
}

export default SecurityComponent;
